module.exports = __webpack_public_path__ + "static/media/magazzino_thumb_even.a1a42f05.webp";